import { Component } from '@angular/core';

/**
 *
 * */
@Component({
  selector: 'campfire-intro-panel',
  templateUrl: './intro-panel.component.html',
  styleUrls: ['./intro-panel.component.scss']
})
export class IntroPanelComponent {

}

